import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    deleteRatingGroup: [],
    loading: false,
    error: null,
}

const deleteRatingGroupSlice = createSlice({
    name: "deleteRatingGroup",
    initialState,
    reducers: {
        fetchdeleteRatingGroupSuccess: (state, action) => {
            state.loading = false,
                state.deleteRatingGroup = action.payload;
        },
        fetchdeleteRatingGroupFailure: (state, action) => {
            state.loading = false,
                state.error = action.payload;
        },
    },
})

export const {
    fetchdeleteRatingGroupSuccess,
    fetchdeleteRatingGroupFailure,
} = deleteRatingGroupSlice.actions;

export default deleteRatingGroupSlice.reducer;